import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of, throwError } from 'rxjs';
import { EventService } from '../services/event.service';

export const eventResolver: ResolveFn<any> = (route) => {
  const eventService = inject(EventService);
  const eventName = route.params['eventname'];

return eventService.getEventByName(eventName).pipe(
  catchError(err => {
    if (err.status === 404) {
      return of(null);
    }

    return throwError(() => err);
  })
);
};